import {useCallback, useEffect, useState} from 'react';

import {kycService} from '@/services/kycService';
import type {AfriexCountry} from '@/types';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';

const useCountryList = () => {
  const [countryList, setCountryList] = useState<AfriexCountry[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCountryList = useCallback(async () => {
    try {
      setIsLoading(true);
      const {data: countries} = await kycService.getCountryList({});
      setCountryList(countries || []);
    } catch (e) {
      showErrorMessage(
        `Fetching country list failed:${getErrorMessage(e, String(e))}`,
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    // Fire-and-forget: fetchCountryList catches and surfaces its own failures,
    // so this only stops an unexpected throw becoming an unhandled rejection.
    fetchCountryList().catch(() => {});
  }, [fetchCountryList]);

  return {
    countryList: countryList,
    fetchCountryList,
    isLoading,
  };
};

export default useCountryList;
